import NextLink from 'next/link'
import { CSSProperties } from 'react'
import { LuCircleUser } from 'react-icons/lu'

import { CircleAvatar } from '@/lib/core/components/CircleAvatar'
import { routePaths } from '@/lib/core/constants/routes'

import styles from './UserAvatarLink.module.css'
import { getAvatarInitial } from './UserAvatarLink.utils'
import { useUserAvatarLink } from './useUserAvatarLink'

export const UserAvatarLink = () => {
  const { userData, avatarColors, avatarAlt, fleetName } = useUserAvatarLink()
  const hasName = Boolean(userData?.firstName || userData?.lastName)

  return (
    <NextLink href={routePaths.account} className={styles.userLink} data-testid="user-avatar-link">
      {userData?.organization?.avatar ? (
        <CircleAvatar src={userData.organization.avatar} alt={avatarAlt} size={32} />
      ) : hasName ? (
        <span
          className={styles.initialAvatar}
          style={
            {
              background: avatarColors?.background,
              color: avatarColors?.color,
            } as CSSProperties
          }
        >
          {getAvatarInitial(userData?.firstName ?? '')}
        </span>
      ) : (
        <LuCircleUser size={22} />
      )}
      {fleetName && (
        <span className={styles.fleetName} data-testid="fleet-name">
          {fleetName}
        </span>
      )}
    </NextLink>
  )
}
